import {FC, MouseEventHandler} from "react";
import {useTranslation} from "react-i18next";
import {ChevronLeftIcon} from "@interstate/components/Icons";
import {Button} from "@interstate/components/Button";
import {useNavigation} from "../../../../../navigation";
import {EntitySourceType} from "../../../../EntitySourceType";
import {usePlan} from "../../context";

interface FailureControlsProps {
  onStepBack: MouseEventHandler<HTMLButtonElement>;
  onRetry: MouseEventHandler<HTMLButtonElement>;
}

export const FailureControls: FC<FailureControlsProps> = ({
  onStepBack,
  onRetry
}) => {
  const {t} = useTranslation();
  const {plan} = usePlan();
  const {navigateToEntityFromEvent} = useNavigation();

  return (
    <div data-testid="stepper-controls" className="stepper-controls">
      <div
        data-testid="stepper-controls-left"
        className="stepper-controls-left">
        <Button
          data-testid="stepper-navigation-previous-button"
          buttonStyle="secondary"
          startIcon={<ChevronLeftIcon />}
          onClick={onStepBack}>
          {t("create-organization.stepper.step-labels.review-plan")}
        </Button>
      </div>
      <div
        data-testid="stepper-controls-right"
        className="stepper-controls-right">
        <Button
          data-testid="step-action-cancel-button"
          buttonStyle="tertiary"
          disabled={false}
          onClick={event =>
            navigateToEntityFromEvent(
              event,
              plan.source.caId,
              EntitySourceType.CLIENT_HIERARCHY
            )
          }>
          {t("create-organization.stepper.controls.actions.cancel")}
        </Button>
        <Button
          data-testid="step-action-create-button"
          buttonStyle="primary"
          onClick={onRetry}
          isLoading={false}>
          {t("create-organization.stepper.controls.actions.retry")}
        </Button>
      </div>
    </div>
  );
};
